var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGems(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gems_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 345.33 345.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gems_svg__linear-gradient",
    x1: 28.52,
    y1: 336.02,
    x2: 199.85,
    y2: 145.03,
    gradientTransform: "matrix(1 0 0 -1 0 348)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#DBA94F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D29B38"
  })), /*#__PURE__*/React.createElement("style", null, ".gems_svg__cls-2{fill:#fff}"))), /*#__PURE__*/React.createElement("g", {
    id: "gems_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gems_svg__Color_icons",
    "data-name": "Color icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gems_svg__Gems"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#gems_svg__linear-gradient)"
    },
    d: "M0 0h345.33v345.33H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "gems_svg__cls-2",
    d: "M248.37 182.88c-4.74-43.35-27.53-77.54-44.27-77.54-15.23 0-11.66 16.92-31.43 16.92s-16.2-16.92-31.44-16.92c-17.13 0-39.67 33.58-44.3 77.51 10.39 10.83 33.21 23.47 75.74 23.47s65.33-12.62 75.7-23.44Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "gems_svg__cls-2",
    d: "M252.64 199.3c-15 11.95-40.31 22.1-80 22.1s-65-10.15-80-22.1c-24.2 2.46-40.61 5.77-40.61 11C52 221.43 114.29 240 172.62 240s120.58-18.57 120.58-29.7c.05-5.23-16.36-8.54-40.56-11Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGems);
export default __webpack_public_path__ + "static/media/gems.67064cf4be8a45fe2ac68a84d6d5b154.svg";
export { ForwardRef as ReactComponent };